import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonUtility, Announcement, AgGridUtility, DateUtility, ServerConstantsService, SINGLE_ROW_HEADER, DataService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { ProviderService } from "../provider-management/provider-management.service";



@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})

export class AnnouncementsComponent implements OnInit, CanComponentDeactivate {


  announcement: Announcement;
  announcementPrev: Announcement;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER
  serverConstants: any;
  userActionNotificationsMap: any;
  isEditable: Boolean = false;
  isShow: Boolean = false;
  minEffectiveFromDt: any;
  minEffectiveToDt: any;

  priorityRefData;
  priorityJson: any;
  priorityMap: any;

  countyList: any = [];
  countyRefData;
  countyArray: any[];
  countiesJson: any;

  countiesMap: any;
  counties: any;

  sharedData: any;
  isChangeDetected: boolean;
  inCorrectDate = false;
  dropdownSettings: any = {};
  countiesModel = [];

  @ViewChild('headerText') headerText: ElementRef;

  constructor(
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
    private providerService: ProviderService,
  ) {
    this.announcement = new Announcement();
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('ANCMT') == undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();
    let id = this.dataService.getSharedDataObject().get("providerId");
    this.providerService.getcountyDetails(id).subscribe((data) => {
      let entities: Array<any> = [];
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < this.countyRefData.length; j++) {
          if (data[i].serviceCounty == this.countyRefData[j].value) {
            entities.push(this.countyRefData[j]);
          }
        }
      }
      this.countyList = entities;
      if (this.sharedData.get('announcement') !== undefined) {
        this.announcement = this.sharedData.get('announcement');
        this.editAnnouncements();
      }
      else {
        this.announcement = new Announcement();
        this.addNewAnnouncements();
      }
    });

    this.dataService.globalAccess = true;
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);


    this.priorityRefData = this.data.getValueFromSharedDataMap('PRIORITY');
    this.priorityMap = this.commonUtil.createMapFromList(this.priorityRefData);
    this.priorityJson = this.commonUtil.createNativeMapFromList(this.priorityRefData);

    this.countyRefData = this.data.getValueFromSharedDataMap('COUNTIES');

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };
  }

  onItemSelect(item: any) {
    this.isChangeDetected = true;
  }

  onSelectAll(items: any) {
    for (let item of items) {
      this.onItemSelect(item);
    }
    this.isChangeDetected = true;
  }

  onItemDeselectCounty(deselectStatus) {
    this.countiesModel.forEach((status, index) => {
      if (status === deselectStatus) this.countiesModel.splice(index, 1);
    });
    event.stopPropagation();
    this.isChangeDetected = true;
  }

  editAnnouncements() {
    this.isEditable = true;
    this.isShow = true;
    if (this.countyRefData !== undefined && this.countyRefData.length > 0 && this.countyRefData[0].value === undefined) {
      this.countyRefData[0].name = this.announcement.counties;
    }
    if (this.announcement.counties !== undefined && this.announcement.counties !== null) {
      this.countiesModel = this.announcement.counties;
      for (let i = 0; i < this.announcement.counties.length; i++) {
        for (let j = 0; j < this.countyList.length; j++) {
          if (this.announcement.counties[i] == this.countyList[j].value) {
            this.countiesModel[i] = this.countyList[j];
          }
        }
      }
    }
    this.announcement.effectiveFromDt = this.dateUtility.convertDateFromServer(this.announcement.effectiveFromDt);
    this.announcement.effectiveToDt = this.dateUtility.convertDateFromServer(this.announcement.effectiveToDt);
    this.announcementPrev = Object.assign({}, this.announcement);
  }

  addNewAnnouncements() {
    this.isEditable = false;
    this.isShow = false;
    const today = new Date();
    this.minEffectiveFromDt = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(today));
    this.announcement = new Announcement();
    this.announcement.audienceCd = 'PS';
    this.announcement.providers = this.sharedData.get('providerId');
    this.announcement.publishedBy = 'P';
    this.announcementPrev = Object.assign({}, this.announcement);

  }

  validate() {
    if (this.announcement.effectiveFromDt !== undefined) {
      this.minEffectiveToDt = {
        day: this.announcement.effectiveFromDt.day,
        month: this.announcement.effectiveFromDt.month,
        year: this.announcement.effectiveFromDt.year
      }
    }
  }

  dataChanges() {
    this.isChangeDetected = true;
  }
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };

  checkEndDate() {
    const formattedStartDate = new Date(this.dateUtility.convertDateForServer(this.announcement.effectiveFromDt));
    const formattedEndDate = new Date(this.dateUtility.convertDateForServer(this.announcement.effectiveToDt));
    const calculatedValue = this.dateUtility.compareDate(formattedStartDate, formattedEndDate);
    if (calculatedValue === 1) {
      this.inCorrectDate = true;
    } else {
      this.inCorrectDate = false;
    }
  }

  save() {
    this.modalPopupService.setChangeDetected(false);
    if (this.countiesModel.length > 0) {
      let list = [];
      for (let i = 0; i < this.countiesModel.length; i++) {
        list.push(this.countiesModel[i].value);
      }
      this.announcement.counties = list.toString();
    } else {
      this.notificationService.error('Please select Counties form the drop-down.');
      return;
    }
    const request = Object.assign({}, this.announcement);
    request.effectiveFromDt = this.dateUtility.convertDateForServer(this.announcement.effectiveFromDt);
    request.effectiveToDt = this.dateUtility.convertDateForServer(this.announcement.effectiveToDt);

    if (!this.inCorrectDate) {
      this.http.post<Announcement>(this.serverConstants.SERVER_API_URL + '/announcements/provider/save', request)
        .subscribe(
          (response: Announcement) => {
            if (response.hasOwnProperty('errorCode')) {
              this.notificationService.error('Announcements', this.userActionNotificationsMap.ERROR);
            } else {
              this.isChangeDetected = false;
              this.announcement = response;
              this.router.navigate(['task/announcementsSummary']);
              this.notificationService.success('Announcement ', this.userActionNotificationsMap.UPDATE);
            }
          },
          (response) => {
            this.notificationService.error('Announcements', this.userActionNotificationsMap.ERROR);
          },
          () => {
          });
    }
  }

  reset() {
    this.addNewAnnouncements();
   this.countiesModel = []
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Announcements/announcements.component.ts